import React, { useState, useEffect, Fragment, lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const LoginOrSignup = lazy(() =>
  import(
    /* webpackChunkName: "LoginOrSignup" */ "../components/Login/LoginOrSignup"
  )
);
const VerifyEmail = lazy(() =>
  import(
    /* webpackChunkName: "UnsubscribeFromMailingList" */ "../components/VerifyEmail/VerifyEmail"
  )
);

// Redux stuff
import { connect } from "react-redux";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function verifyEmail(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Email Verification - Content Generator`}
        description={`Complete your Content Generator account setup by verifying your email address. Get full access to all premium features, including post creation, scheduling, and automation tools.`}
        url={`https://contentgenerator.io/verify-email`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          {props.user.authenticated ? <VerifyEmail /> : <LoginOrSignup />}
        </Suspense>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

export default connect(mapStateToProps)(verifyEmail);
